// extracted by mini-css-extract-plugin
export var container = "_s7-0";
export var dotAnimation = "_s7-2";
export var dotsLoading = "_s7-1";